// extracted by mini-css-extract-plugin
export default {"contextMenuLabel":"contextMenuLabel__V_tKxK","shortcut":"shortcut__vmzGDW"};